import * as c from 'utils/constants/constants';
import { wampCall } from 'utils/initUtils';
import { getLegacyLanguageId } from 'utils/localeUtils';

export enum inviteType {
  email = 'email',
  emailShort = 'emailShort',
  textMessage = 'textMessage'
}

const ACCOUNT_SETTINGS_ENDPOINT = 'lifesize.account.settings';
const GET_EXTENSION_INVITE_TEXT_URI = 'customInvite';
const HTTP_GET = 'GET';

/**
 * retrieves the invite text { subject, body } for the provided extension.
 * @param {string} extension The extension to generate the invite text for
 * @param {'email'|'emailShort'|'textMessage'} type Flag to indicate the invite type
 * @returns {object} Invite text as { subject, body }
 */
const getExtensionInviteText = async (extension: string, type: inviteType = inviteType.email) => {
  try {
    if (!extension) {
      throw new Error(`getExtensionInviteText() - Invalid argument extension: ${extension}`);
    }
    let language = getLegacyLanguageId();
    // custom invites does not accept 'pt', 'zh-CN', or 'zh-TW'
    switch (language) {
      case 'pt':
        language = 'pt_BR';
        break;
      case 'zh-CN':
        language = 'zh_CN';
        break;
      case 'zh-TW':
        language = 'zh_TW';
        break;
      default:
        //do nothing
    }
    const queryParams = JSON.stringify({
      extension,
      language,
      type
    });
    const funcCall = JSON.stringify({
      uriSuffix: GET_EXTENSION_INVITE_TEXT_URI,
      httpMethod: HTTP_GET,
      inputParams: null,
      queryParams
    });
    const results = await wampCall({ procedure: ACCOUNT_SETTINGS_ENDPOINT, args: [funcCall] });
    const parsedResults = JSON.parse(results);
    // check status code of response
    if (parsedResults.statusCode && parsedResults.statusCode >= 400) {
      throw parsedResults;
    }
    return parsedResults.body;
  } catch (e) {
    throw e;
  }
};

export function getCallLink(extension: string) {
  if (extension) {
    return `${c.otherWaysToCall}${extension}`;
  }
  return '';
}

export { getExtensionInviteText };
